const OrderList = () => import('../../views/order/OrderList.vue');
const OrderDetail = () => import('../../views/order/OrderDetail.vue');

const Container = {
  template: `
    <div class="Container">
      <router-view></router-view>
    </div>
  `,
};

const router = {
  path: '/order/orderList',
  name: 'OrderContainer',
  component: Container,
  meta: {
    title: '订单管理',
    icon: 'tickets',
    hideChildren: true,
  },
  children: [
    {
      path: '',
      name: 'OrderList',
      component: OrderList,
      meta: {
        title: '订单列表',
        hideChildren: true,
      },
    },
    {
      path: '/order/orderDetail/:orderId',
      name: 'OrderDetail',
      component: OrderDetail,
      meta: {
        title: '订单详情',
        hideChildren: true,
        light: '/order/orderList',
      },
    },
  ],
};
export default router;



// WEBPACK FOOTER //
// ./src/router/modules/order.js